import { Link, Navigate, useParams } from "react-router";
import Seo from "../components/Seo";
import BlogHtmlContent from "../components/BlogHtmlContent";
import { getBlogArticle } from "./blogs/blogRegistry";
import { getBlogCover } from "./blogs/blogImages";
import { normalizeBlogSlug } from "./blogs/parseBlogHtml";
import { SITE_URL } from "../seo/site";

function BlogArticlePage({ onAdvisorClick }) {
  const { slug: rawSlug } = useParams();
  const slug = normalizeBlogSlug(rawSlug);
  const article = getBlogArticle(slug);
  const cover = getBlogCover(slug);

  if (!article) {
    return <Navigate to="/blog" replace />;
  }

  if (rawSlug !== slug) {
    return <Navigate to={`/blog/${slug}`} replace />;
  }

  return <main className="vd-page vd-blog-page">
      <Seo
        title={article.title}
        description={article.description}
        path={article.path}
        type="article"
        image={`${SITE_URL}${cover.src}`}
        jsonLd={[
          ...(article.jsonLd || []),
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
              { "@type": "ListItem", position: 2, name: "Blog", item: `${SITE_URL}/blog` },
              { "@type": "ListItem", position: 3, name: article.title, item: `${SITE_URL}${article.path}` }
            ]
          }
        ]}
      />

      <div className="vd-blog-toolbar">
        <Link to="/blog" className="vd-blog-back">← All Guides</Link>
      </div>

      <figure className="vd-blog-cover">
        <img src={cover.src} alt={cover.alt} width="1200" height="630" loading="eager" />
      </figure>

      <BlogHtmlContent
        styles={article.styles}
        html={article.bodyHtml}
        onAdvisorClick={onAdvisorClick}
      />
    </main>;
}

export default BlogArticlePage;
